export const createSellData = [
  {
    icon: "./assets/create-icon.svg",
    header: "Set Up Your Wallet",
    desc: `Once you’ve set up your wallet of choice,
     connect it to 
    OpenSea by clicking the wallet icon in the top right corner.`,
  },
  {
    icon: "./assets/create-icon.svg",
    header: "Add your NFTs",
    desc: `Once you’ve set up your wallet of choice,
     connect it to 
    OpenSea by clicking the wallet icon in the top right corner.`,
  },
  {
    icon: "./assets/create-icon.svg",
    header: "List Them For Sale",
    desc: `Once you’ve set up your wallet of choice,
     connect it to 
    OpenSea by clicking the wallet icon in the top right corner.`,
  },
];
